var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'app-side',
    !_vm.isExpand && _vm.modal ? _vm.position : '',
    { modal: _vm.modal },
    { expand: !_vm.isExpand && _vm.modal },
    _vm.isScreen && _vm.screenClass,
  ],on:{"click":function($event){if($event.target !== $event.currentTarget)return null;return _vm.cancel.apply(null, arguments)}}},[(_vm.isHandle)?_c('div',{class:[
      !_vm.isExpand ? 'icon-lunan-shousuocaidan' : 'icon-lunan-shousuocaidan-copy',
      ,
      !_vm.isExpand ? 'icon-translate' : '',
      ,
      _vm.position,
      'iconfont-lunan',
      'app-side-button',
    ],style:(_vm.position + ':' + _vm.width + 'px'),on:{"click":_vm.handleSwitch}}):_vm._e(),_c('div',{class:[
      'app-side-panel',
      _vm.position,
      { expand: !_vm.isExpand },
      { transparent: _vm.transparent },
      _vm.isScreen && _vm.screenClass,
    ],style:({ width: _vm.width + 'px', top: _vm.top + 'px' })},[(_vm.title || _vm.$slots.title)?_c('div',{staticClass:"app-side-panel__header"},[_vm._t("title",function(){return [_c('span',{staticClass:"app-side-panel-title"},[_vm._v(_vm._s(_vm.title))])]}),_c('span',[(!_vm.isClose)?_c('i',{staticClass:"el-icon-close icon",attrs:{"title":"关闭"},on:{"click":function($event){$event.stopPropagation();return _vm.cancel.apply(null, arguments)}}}):_vm._e(),(_vm.isScreen)?_c('i',{staticClass:"el-icon-full-screen",staticStyle:{"margin":"0 10px"},attrs:{"title":"全屏展示"},on:{"click":function($event){$event.stopPropagation();return _vm.handleScreen.apply(null, arguments)}}}):_vm._e()])],2):_vm._e(),_c('div',{staticClass:"app-side-panel__body"},[_vm._t("default")],2),(_vm.$slots.footer)?_c('div',{staticClass:"app-side-panel__footer"},[_vm._t("footer")],2):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }